'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyPathOnChannel = getKeyPathOnChannel;
function getKeyPathOnChannel(channel, path) {
  return [channel].concat(path);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/models/ConversationsModel.js
// module id = 527
// module chunks = 0